import React, {useRef, useEffect} from 'react';

import "./ModalContentWrapper.scss";

const ModalContentWrapper = (props) =>
{
    const refContainer = useRef(null);

    useEffect(() => {

        if ( props.onScrollBottomReached !== undefined )
        {
            refContainer.current.scrollTop = 0;

            const scrollHeight = refContainer.current.scrollHeight;
            const clientHeight = refContainer.current.clientHeight;

            if (scrollHeight <= clientHeight)
            {
                props.onScrollBottomReached();
            }
        }
    }, []);

    const isScrollBottomHandlerRequired = () =>
    {
        return props.onScrollBottomReached !== undefined;
    }

    const handleScroll = (e) =>
    {
        const diff = parseInt((e.target.scrollHeight - e.target.scrollTop), 10);

        const n1 = +diff;
        const n2 = +(e.target.clientHeight);

        if (Math.abs(n1 - n2) < 5)
        {
            if (props.onScrollBottomReached !== undefined)
            {
                props.onScrollBottomReached();
            }
        }
    }

    const handler = isScrollBottomHandlerRequired() ? handleScroll : null;

    const style = props.width !== undefined ? {width: props.width} : {};

    if (props.columns === 2)
    {
        return (
            <div ref={refContainer} className="s360-modal-content" onScroll={handler}>
                <div className='modal-two-column' style={style}>
                    {props.children}
                </div>
            </div>
        )
    }
    else
    {
        return (
            <div ref={refContainer} className="s360-modal-content" onScroll={handler}>
                <div className='modal-one-column' style={style}>
                    {props.children}
                </div>
            </div>
        )
    }
}

export default ModalContentWrapper;